import React from 'react';
import { palette } from 'src/styles/colors';
import Paragraph from 'src/elements/typography/paragraph';
import { GetDetailsLink, NovemberOfferAnnouncementContainer } from './NovemberOfferAnnouncement.styles';

const NovemberOfferAnnouncement = (): JSX.Element => {
  return (
    <NovemberOfferAnnouncementContainer>
      <Paragraph
        standardSize='1'
        align='center'
        color={palette.white}
        sizeXxs='0.875rem'
      >
        LIMITED TIME OFFER—Unlock Extra Features on Our Most Popular Plans{' '}
        <GetDetailsLink to='/november-offer'>Get the Details</GetDetailsLink>
      </Paragraph>
    </NovemberOfferAnnouncementContainer>
  );
};

export default NovemberOfferAnnouncement;
